<div *ngIf="shouldShowBanner" class="banner-container">
  <div class="banner-content">
    <button class="close-button" (click)="dismissBanner()">
      <img src="assets/images/icons/close.svg" alt="Close banner" />
    </button>
    <span>View in TechInsights App</span>
    <button class="cta-button" (click)="openApp()">Open</button>
  </div>
</div>